"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MyAccountDisplayMode;
(function (MyAccountDisplayMode) {
    MyAccountDisplayMode["AUTH_SCREEN"] = "authScreen";
    MyAccountDisplayMode["LOGIN_BUTTON"] = "loginButton";
})(MyAccountDisplayMode = exports.MyAccountDisplayMode || (exports.MyAccountDisplayMode = {}));
